import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const LOGO = "https://customer-assets.emergentagent.com/job_telemedicine-plus-1/artifacts/si76u1vy_image.png";

export default function Navbar() {
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 glass border-b border-white/40"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#top" data-testid="brand-logo-link" className="flex items-center gap-3">
          <img src={LOGO} alt="HappiBandhu" className="h-15 w-20 object-contain" />
          <div className="hidden sm:block leading-tight">
            <div className="font-display font-bold text-lg text-[color:var(--brand-navy)]">
              HappiBandhu
            </div>
            <div className="text-[10px] tracking-[0.18em] uppercase text-[color:var(--brand-magenta)] font-semibold">
              Har Parivaar Ka Apna Bandhu
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-700">
          <a href="#plans" data-testid="nav-plans" className="hover:text-[color:var(--brand-navy)]">
            Plans
          </a>
          <a href="#benefits" data-testid="nav-benefits" className="hover:text-[color:var(--brand-navy)]">
            Benefits
          </a>
          {/* <a href="#plan" data-testid="nav-plan" className="hover:text-[color:var(--brand-navy)]">
            Plan
          </a> */}
          <a href="#faq" data-testid="nav-faq" className="hover:text-[color:var(--brand-navy)]">
            FAQ
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <a href="#plan" data-testid="nav-plan-cta">
            <Button
              size="sm"
              className="bg-[color:var(--brand-magenta)] hover:bg-[color:var(--brand-magenta-deep)] text-white shadow-md hover:shadow-lg transition-all"
            >
              Enroll Now
            </Button>
          </a>
        </div>
      </div>
    </header>
  );
}
